var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { logger, updateSearch } from 'bernie-core';
import { Footer } from '@gc/global-components';
import { CustomerNotificationLocation } from '@shared-ui/customer-notifications';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { ActivityReviews } from '@shared-ui/retail-activities-activity-reviews';
import { DirectFeedback } from '@shared-ui/retail-activities-direct-feedback';
import { NavigationBar } from '@shared-ui/retail-activities-navigation-bar';
import { NotFound } from '@shared-ui/retail-activities-not-found';
import { LineOfBusinessDomain, OneKeyBanner, PageLocation } from '@shared-ui/retail-loyalty-one-key-banner';
import { OneKeyMessageCardQuery } from '@shared-ui/retail-loyalty-one-key-message-card-query';
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { PartnerMemberMessageCards } from '@shared-ui/retail-wlt-partner-messaging';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';
import { ReactPortalProvider } from '@shared-ui/portal-context';
import { Recommendations } from '@shared-ui/retail-activities-recommendations';
import { ErrorBoundary } from 'bernie-view';
import { ActivityFaqs } from '@shared-ui/retail-activities-activity-faqs';
import { ActivityMessageType } from '../common/__generated__/api';
import { getPageName, PageId } from '../utils/page-ids';
import { keyboardFocusProps, NavigationRefs } from '../utils/accessibility';
import useQueryParams from '../utils/hooks/useQueryParams';
import { useStores } from '../utils/hooks';
import { ActivityDetailsViewTemplate } from '../utils/view-templates';
import { trackInventoryErrorEvent, updateBackToSearchISQuery } from '../helpers/activity-detail-helper';
import { getIsoFormatDateFromDateString } from '../helpers/date-helper';
import { ActivityPreload } from './activity-details/activity-preload';
import { ImageGallerySection } from './activity-details/image-gallery';
import { ActivityOverview } from './activity-details/overview';
import { PartnerContents } from './activity-details/partner-contents';
import { OffersComponent } from './activity-details/shared-ui';
import { StaticDetailsSection } from './activity-details/static-details';
import { TabbedNavigationBar } from './activity-details/tabbed-navigation-bar';
import { ActivityMessageBanner, mapLocalisationDisclaimerToBannerProps, mapPromotionMessageToBannerProps, trackAction } from './common/banners';
import { mapLegalDisclaimerToBannerProps } from './common/banners/activity-message-banner-helper';
import { CustomerNotifications } from './common/customer-notifications';
import { VoiceOfCustomer } from './common/voice-of-customer';
import { MesoDisplayAd } from './meso';
import { getUpdatedFilterQueryObjectForPDP } from './srp/sort-filter/universal-sort-filter-utils';
import { SimpleLazyLoadWrapper } from '../common/component/simple-lazy-load-wrapper';
var MemoizedFooter = React.memo(Footer);
var REVIEWS_SECTION_REF = 'reviews';
var FAQS_REF = 'faqs';
export var ActivityDetail = logger('activity-details')(
// eslint-disable-next-line @typescript-eslint/no-shadow, @typescript-eslint/no-unused-vars
observer(function (_a) {
  var _b, _c, _d, _e, _f, _g;
  var logger = _a.logger;
  var _h = useStores(),
    activityDetailStore = _h.activityDetailStore,
    detailCriteriaStore = _h.detailCriteriaStore,
    analytics = _h.analytics,
    advertising = _h.advertising;
  var location = useLocation();
  var queryParams = useQueryParams();
  var preview = queryParams.preview === 'true';
  var requestDate = queryParams.requestDate;
  var history = useHistory();
  var _j = __read(React.useState(false), 2),
    isCampaignDealsOmnitureTriggered = _j[0],
    setIsCampaignDealsOmnitureTriggered = _j[1];
  var navigationRefs = NavigationRefs;
  var experimentStore = activityDetailStore.getExperimentStore();
  var activityDetail = activityDetailStore.activityDetail;
  var presentation = activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.presentation;
  var banners = presentation === null || presentation === void 0 ? void 0 : presentation.banners;
  var partnerProvidedDetails = (presentation === null || presentation === void 0 ? void 0 : presentation.partnerProvidedDetails) && ((_b = presentation === null || presentation === void 0 ? void 0 : presentation.partnerProvidedDetails) === null || _b === void 0 ? void 0 : _b.length) > 0 ? presentation.partnerProvidedDetails : null;
  var overviewSectionRef = activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.activity.sectionRef;
  var tabs = (_c = activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.tabbedNavigationBar) === null || _c === void 0 ? void 0 : _c.tabs;
  var saveItem = (_d = activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.activity) === null || _d === void 0 ? void 0 : _d.saveItem;
  var saveButtonRef = React.useRef(null);
  var findTicketsButton = (_e = activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.tabbedNavigationBar) === null || _e === void 0 ? void 0 : _e.findTicketsButton;
  var findTicketsAction = (_f = activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.tabbedNavigationBar) === null || _f === void 0 ? void 0 : _f.findTicketsAction;
  var activityReviewsInputs = {
    activityId: activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.activity.id,
    pagination: {
      size: 10,
      startingIndex: 0
    }
  };
  var detailQuery = detailCriteriaStore.detailQuery;
  var regionId = detailQuery.rid || '';
  var localDateFormat = detailCriteriaStore.localDateFormat;
  var startDate = getIsoFormatDateFromDateString(detailQuery.startDate, localDateFormat);
  var endDate = getIsoFormatDateFromDateString(detailQuery.endDate, localDateFormat);
  var tabNavigationRef = React.useRef(null);
  NavigationRefs.tabNavigationRef = tabNavigationRef;
  var reactPortalContext = typeof window === 'undefined' ? {
    htmlElement: undefined
  } : {
    htmlElement: document.body
  };
  advertising.trigger(getPageName(PageId.ACTIVITY_DETAIL));
  var setPageTitle = function () {
    if ((activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.presentation.title) && typeof document !== 'undefined') {
      document.title = activityDetailStore.activityDetail.presentation.title;
    }
  };
  var updateQueryString = function () {
    updateBackToSearchISQuery(history, location, detailCriteriaStore);
  };
  React.useEffect(function () {
    if (experimentStore && banners) {
      trackInventoryErrorEvent(experimentStore, banners, analytics);
    }
    analytics.markPageUsable();
  }, []);
  React.useEffect(function () {
    var promotionMessage = activityDetail === null || activityDetail === void 0 ? void 0 : activityDetail.presentation.promotionMessage;
    var promotionAnalytics = (promotionMessage === null || promotionMessage === void 0 ? void 0 : promotionMessage.type) === ActivityMessageType.SOURCED_CAMPAIGN ? promotionMessage === null || promotionMessage === void 0 ? void 0 : promotionMessage.analytics : null;
    if (!isCampaignDealsOmnitureTriggered && (promotionAnalytics === null || promotionAnalytics === void 0 ? void 0 : promotionAnalytics.referrerId) && analytics) {
      trackAction(promotionAnalytics.referrerId, promotionAnalytics === null || promotionAnalytics === void 0 ? void 0 : promotionAnalytics.linkName, analytics, []);
      setIsCampaignDealsOmnitureTriggered(true);
    }
  }, [activityDetail, analytics, isCampaignDealsOmnitureTriggered]);
  React.useEffect(function () {
    setPageTitle();
    updateQueryString();
  });
  var isLoyaltyPointsToggleOn = !(detailQuery.swp && detailQuery.swp === 'off');
  var oneKeyToggleHandler = React.useCallback(function (isChecked) {
    var swpValue = isChecked ? 'on' : 'off';
    updateSearch({
      history: history,
      location: location,
      newParams: {
        swp: swpValue
      },
      newState: {},
      replace: true
    });
    detailCriteriaStore.detailQuery = __assign(__assign({}, detailCriteriaStore.detailQuery), {
      swp: swpValue
    });
  }, [updateSearch, activityDetailStore]);
  if (activityDetailStore.isDetailFetchError) {
    return React.createElement(UitkSpacing, {
      margin: {
        blockstart: 'twelve'
      }
    }, React.createElement(NotFound, {
      inputs: {
        activityId: detailCriteriaStore.activityId
      }
    }));
  }
  if (!activityDetail) {
    var activityPreloadedData = activityDetailStore.activityPreloadedData;
    return React.createElement("div", {
      "data-testid": "activity-preloaded--detail"
    }, activityPreloadedData && React.createElement(ActivityPreload, {
      activity: activityPreloadedData.activity
    }));
  }
  var footerCSR = React.createElement(ErrorBoundary, {
    label: "lx.splitview.footer"
  }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(MemoizedFooter, {
    skipSsr: true,
    page: (_g = getPageName(PageId.ACTIVITY_DETAIL)) !== null && _g !== void 0 ? _g : 'Unknown'
  })));
  return React.createElement(React.Fragment, null, React.createElement(ActivityDetailsViewTemplate, {
    afterHeaderNotification: React.createElement(UitkSpacing, {
      margin: {
        block: 'three'
      }
    }, React.createElement(CustomerNotifications, {
      location: CustomerNotificationLocation.AFTER_HEADER,
      regionId: regionId,
      startDate: startDate,
      endDate: endDate
    })),
    oneKeyMessageCard: React.createElement(Experiment, {
      name: "eg_one_key_client"
    }, React.createElement(ExperimentControl, null, React.createElement(React.Fragment, null)), React.createElement(ExperimentVariant, {
      bucket: 1
    }, React.createElement(UitkSpacing, {
      margin: {
        medium: {
          blockend: 'three'
        }
      }
    }, React.createElement("div", null, React.createElement(OneKeyMessageCardQuery, {
      inputs: {
        pageLocation: PageLocation.DETAILS,
        lineOfBusiness: LineOfBusinessDomain.ACTIVITIES
      }
    }))))),
    backToSearch: React.createElement(UitkSpacing, {
      padding: {
        inline: 'two',
        block: 'two'
      }
    }, React.createElement("nav", {
      className: "uitk-card-separator-bottom uitk-view-row-theme-primary",
      "aria-label": "primary"
    }, React.createElement(ReactPortalProvider, {
      reactPortalContext: reactPortalContext
    }, React.createElement(UitkSpacing, {
      margin: {
        block: 'three'
      }
    }, React.createElement(CustomerNotifications, {
      location: CustomerNotificationLocation.IN_PAGE,
      regionId: regionId,
      startDate: startDate,
      endDate: endDate
    })), React.createElement("div", {
      ref: saveButtonRef
    }, React.createElement(NavigationBar, {
      inputs: {
        activityId: detailCriteriaStore.activityId,
        dateRange: detailCriteriaStore.detailVariables.dateRange,
        destination: detailCriteriaStore.detailVariables.destination,
        searchFilters: getUpdatedFilterQueryObjectForPDP(new URLSearchParams(location.search))
      }
    }))))),
    imageGallery: React.createElement("figure", {
      "data-testid": "activity-overview--image-gallery"
    }, React.createElement(ImageGallerySection, null)),
    tabNavigatorTop: tabs && tabs.length > 0 && React.createElement("div", {
      "data-testid": "navigation-bar-top",
      ref: tabNavigationRef,
      role: "navigation",
      "aria-label": "in page"
    }, React.createElement(TabbedNavigationBar, {
      saveItem: saveItem,
      saveButtonRef: saveButtonRef,
      navigationBarTabList: tabs,
      findTicketsButton: findTicketsButton,
      findTicketsAction: findTicketsAction,
      analytics: analytics,
      navigationRefs: navigationRefs
    })),
    discountBanner: (presentation === null || presentation === void 0 ? void 0 : presentation.promotionMessage) && React.createElement(Viewport, null, React.createElement(ViewSmall, null, React.createElement(UitkSpacing, {
      margin: {
        blockend: 'three',
        inline: 'three'
      }
    }, React.createElement(ActivityMessageBanner, __assign({}, mapPromotionMessageToBannerProps(presentation.promotionMessage))))), React.createElement(ViewLarge, null, React.createElement(UitkSpacing, {
      margin: {
        small: {
          inline: 'three'
        },
        blockstart: 'three'
      }
    }, React.createElement(ActivityMessageBanner, __assign({}, mapPromotionMessageToBannerProps(presentation.promotionMessage)))))),
    oneKeyBanner: React.createElement(Experiment, {
      name: "eg_one_key_client"
    }, React.createElement(ExperimentControl, null, React.createElement(React.Fragment, null)), React.createElement(ExperimentVariant, {
      bucket: 1
    }, React.createElement(UitkSpacing, {
      margin: {
        blockstart: 'six'
      }
    }, React.createElement(OneKeyBanner, {
      inputs: {
        useLoyaltyCurrency: isLoyaltyPointsToggleOn,
        pageLocation: PageLocation.DETAILS,
        lineOfBusiness: LineOfBusinessDomain.ACTIVITIES
      },
      switchHandler: oneKeyToggleHandler
    })))),
    partnerMemberMessageCards: React.createElement(PartnerMemberMessageCards, {
      inputs: {
        lineOfBusiness: 'ACTIVITIES',
        pageType: 'PDP',
        preview: preview,
        requestDate: requestDate
      }
    }),
    offers: React.createElement(Experiment, {
      name: "LX_PDP_bundled_queries"
    }, React.createElement(ExperimentControl, null, React.createElement(UitkSpacing, {
      margin: {
        blockstart: 'six'
      }
    }, React.createElement("div", null, React.createElement(Experiment, {
      name: "eg_one_key_client"
    }, React.createElement(ExperimentControl, null, React.createElement(OffersComponent, null)), React.createElement(ExperimentVariant, {
      bucket: 1
    }, React.createElement(OffersComponent, {
      oneKeyToggleState: isLoyaltyPointsToggleOn
    })))))), React.createElement(ExperimentVariant, {
      bucket: 1
    }, React.createElement(Viewport, null, React.createElement(ViewSmall, null, React.createElement(UitkSpacing, {
      margin: {
        blockstart: 'six'
      }
    }, React.createElement("div", null, React.createElement(Experiment, {
      name: "eg_one_key_client"
    }, React.createElement(ExperimentControl, null, React.createElement(OffersComponent, {
      skipSsr: true
    })), React.createElement(ExperimentVariant, {
      bucket: 1
    }, React.createElement(OffersComponent, {
      oneKeyToggleState: isLoyaltyPointsToggleOn,
      skipSsr: true
    })))))), React.createElement(ViewMedium, null, React.createElement(UitkSpacing, {
      margin: {
        blockstart: 'six'
      }
    }, React.createElement("div", null, React.createElement(Experiment, {
      name: "eg_one_key_client"
    }, React.createElement(ExperimentControl, null, React.createElement(OffersComponent, null)), React.createElement(ExperimentVariant, {
      bucket: 1
    }, React.createElement(OffersComponent, {
      oneKeyToggleState: isLoyaltyPointsToggleOn
    }))))))))),
    overview: React.createElement(Viewport, null, React.createElement(ViewMedium, null, React.createElement("div", {
      "data-testid": "activity-detail--overview",
      "aria-label": "".concat(overviewSectionRef)
    }, React.createElement(ActivityOverview, {
      key: "overview"
    }))), React.createElement(ViewSmall, null, React.createElement("div", {
      "data-testid": "activity-detail--overview",
      "aria-label": "".concat(overviewSectionRef)
    }, React.createElement(ActivityOverview, {
      key: "overview"
    }), React.createElement(Experiment, {
      name: "eg_one_key_client"
    }, React.createElement(ExperimentControl, null), React.createElement(ExperimentVariant, {
      bucket: 1
    }, React.createElement("section", {
      "data-testid": "details-view--one-key-message-banner"
    }, React.createElement(UitkSpacing, {
      margin: {
        small: {
          blockstart: 'two',
          blockend: 'two'
        }
      }
    }, React.createElement("div", null, React.createElement(OneKeyMessageCardQuery, {
      inputs: {
        pageLocation: PageLocation.DETAILS,
        lineOfBusiness: LineOfBusinessDomain.ACTIVITIES
      }
    }))))))))),
    recommendations: React.createElement(UitkSpacing, {
      margin: {
        small: {
          blockstart: 'three'
        },
        medium: {
          blockstart: 'six'
        }
      }
    }, React.createElement("div", {
      "data-testid": "recommendation-list"
    }, React.createElement(Recommendations, {
      skipSsr: true,
      inputs: {
        dateRange: detailCriteriaStore.detailVariables.dateRange,
        destination: detailCriteriaStore.detailVariables.destination,
        activityId: detailCriteriaStore.activityId
      }
    }))),
    legalDisclaimer: presentation.legalDisclaimer && React.createElement(ActivityMessageBanner, __assign({}, mapLegalDisclaimerToBannerProps(presentation.legalDisclaimer))),
    localisationDisclaimer: presentation.localisationDisclaimer && React.createElement(UitkSpacing, {
      margin: {
        small: {
          blockend: 'three'
        },
        medium: {
          blockstart: 'three',
          blockend: 'unset'
        }
      }
    }, React.createElement(ActivityMessageBanner, __assign({}, mapLocalisationDisclaimerToBannerProps(presentation.localisationDisclaimer)))),
    reviews: React.createElement(UitkSpacing, {
      margin: {
        small: {
          block: 'three'
        },
        large: {
          block: 'six'
        }
      }
    }, React.createElement("div", __assign({}, keyboardFocusProps(REVIEWS_SECTION_REF)), React.createElement(ActivityReviews, {
      skipSsr: true,
      jumplinkTabRefs: navigationRefs,
      inputs: activityReviewsInputs
    }))),
    partnerDetails: partnerProvidedDetails && React.createElement(UitkSpacing, {
      margin: {
        block: 'six'
      },
      padding: {
        block: 'four',
        inline: 'three'
      }
    }, React.createElement("section", {
      className: "uitk-card"
    }, React.createElement(PartnerContents, {
      partnerProvidedDetails: partnerProvidedDetails
    }))),
    staticDetails: React.createElement(UitkSpacing, {
      margin: {
        small: {
          blockstart: 'half'
        },
        medium: {
          blockstart: 'six'
        }
      }
    }, React.createElement(StaticDetailsSection, null)),
    faqs: React.createElement(Experiment, {
      name: "Activities_web_PDP_FAQ_Section",
      logExposure: true
    }, React.createElement(ExperimentControl, null), React.createElement(ExperimentVariant, {
      bucket: 1
    }, React.createElement("div", __assign({}, keyboardFocusProps(FAQS_REF)), React.createElement(ActivityFaqs, {
      skipSsr: true,
      inputs: {
        activityId: detailCriteriaStore.activityId
      }
    })))),
    sideRailAd: React.createElement(Viewport, null, React.createElement(ViewLarge, null, React.createElement(UitkSpacing, {
      margin: {
        inlinestart: 'six'
      }
    }, React.createElement("aside", {
      className: "max-height"
    }, React.createElement(MesoDisplayAd, {
      uci: "R1",
      slot: "R1"
    }), React.createElement(UitkSpacing, {
      margin: {
        blockstart: 'two'
      }
    }, React.createElement("div", {
      className: "sticky-top--with-navbar"
    }, React.createElement(MesoDisplayAd, {
      uci: "R2",
      slot: "R2"
    }))))))),
    footerAd: React.createElement(UitkSpacing, {
      margin: {
        blockstart: 'six'
      }
    }, React.createElement(UitkLayoutFlex, {
      justifyContent: "center"
    }, React.createElement(UitkLayoutFlexItem, null, React.createElement("div", {
      className: "footer-ad"
    }, React.createElement(Viewport, null, React.createElement(ViewLarge, null, React.createElement(MesoDisplayAd, {
      uci: "CM1",
      slot: "CM1"
    })), React.createElement(ViewMedium, null, React.createElement(MesoDisplayAd, {
      uci: "CM2",
      slot: "CM2"
    })), React.createElement(ViewSmall, null, React.createElement(MesoDisplayAd, {
      uci: "CM3",
      slot: "CM3",
      mediaquery: "(max-width: 960px)"
    }))))))),
    directFeedback: React.createElement(UitkSpacing, {
      margin: {
        blockstart: 'six'
      }
    }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(DirectFeedback, {
      inputs: {
        activityId: detailCriteriaStore.activityId,
        dateRange: detailCriteriaStore.detailVariables.dateRange,
        destination: detailCriteriaStore.detailVariables.destination
      },
      skipSsr: true
    }))),
    shareFeedback: React.createElement(UitkSpacing, {
      margin: {
        blockstart: 'six'
      }
    }, React.createElement(VoiceOfCustomer, null)),
    footer: footerCSR
  }));
}));